var map = {
	"./de/general11/slide1.svg": 924975,
	"./en/general11/slide1.svg": 687907,
	"./es/general11/slide1.svg": 169640,
	"./fr/general11/slide1.svg": 37200,
	"./nl/general11/slide1.svg": 795294,
	"./pt/general11/slide1.svg": 880804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147599;